module.exports = __webpack_public_path__ + "static/media/Montserrat-Regular.3fe868a1.ttf";